import { axiosRequest } from "../axios.config";

const closeCaptionApi = {
  getAllCloseCaption: async () => {
    const url = "CloseCaption";
    const response = await axiosRequest.get(url);
    return response;
  },
};

export { closeCaptionApi };
